// extracted by mini-css-extract-plugin
export default {"container":"VideoReport_container__2Rid3","video":"VideoReport_video__e3EXL"};